export default __webpack_public_path__ + "static/media/nrw_light.639e0dc9.png";